import React, { Component } from 'react';
import axios from 'axios';
import { itemInAdjList, itemInStrList } from '../helpers/utils';

export default class UnitTests extends Component {
  constructor(props) {
    super(props);
    this.state = {
      testStatus: '',
      errorLog: [],
      testRunning: false,
      abortTest: false,
      passCount: 0,
      failCount: 0,
    };
  }

  async RunUnitTests() {
    // list of functions containing the unit tests we want to run
    var unitTestArray = [
      // conforming
      this.MTGDU30_Standard, this.MTGDU30_LoanLimitHigh, this.MTGDU30_CondoSecondHomeSecondLoan, this.MTGDU30_2UnitInvestment, this.MTGDU30_4UnitCashOut,
      this.MTGDU30_LtvMax97, this.MTGDU30_LtvOverMax97, this.MTGDU30_FicoMin620, this.MTGDU30_FicoUnder619, this.MTGDU30_DtiOver50,
      this.MTGDU30_2UnitLtvOver95, this.MTGDU30_4UnitLtvOver95, this.MTGDU30_SecondHomeLtv90, this.MTGDU30_SecondHomeLtvOver90, this.MTGDU30_SecondHome2Unit, 
      this.MTGDU30_InvestmentLtv80Fico620, this.MTGDU30_InvestmentLtv85Fico620, this.MTGDU30_InvestmentLtv85Fico680, this.MTGDU30_Investment2UnitLtvOver75, this.MTGDU30_Investment2UnitFico619,
      this.MTGDU30_RateTermPrimarySfrLtv97, this.MTGDU30_RateTermPrimary2UnitLtvOver85, this.MTGDU30_RateTermPrimary3UnitLtvOver75, this.MTGDU30_RateTermInvestment1UnitLtvOver75, this.MTGDU30_RateTermInvestment2UnitLtvOver75,
      this.MTGDU30_CashOutPrimaryPudLtvOver80, this.MTGDU30_CashOutPrimary4UnitLtvOver75, this.MTGDU30_CashOutSecondHomePudLtvOver75, this.MTGDU30_CashOutInvestmentPudLtvOver75, this.MTGDU30_CashOutInvestment3UnitLtvOver70,

      this.MTGDU15_Standard, this.MTGDU15_LoanLimitHigh, this.MTGDU15_CondoSecondHomeSecondLoan, this.MTGDU15_2UnitInvestment, this.MTGDU15_4UnitCashOut,
      this.MTGDU15_LtvMax97, this.MTGDU15_LtvOverMax97, this.MTGDU15_FicoMin620, this.MTGDU15_FicoUnder619, this.MTGDU15_DtiOver50, 
      this.MTGDU15_2UnitLtvOver95, this.MTGDU15_4UnitLtvOver95, this.MTGDU15_SecondHomeLtv90, this.MTGDU15_SecondHomeLtvOver90, this.MTGDU15_SecondHome2Unit, 
      this.MTGDU15_InvestmentLtv80Fico620, this.MTGDU15_InvestmentLtv85Fico620, this.MTGDU15_InvestmentLtv85Fico680, this.MTGDU15_Investment2UnitLtvOver75, this.MTGDU15_Investment2UnitFico619,
      this.MTGDU15_RateTermPrimarySfrLtv97, this.MTGDU15_RateTermPrimary2UnitLtvOver85, this.MTGDU15_RateTermPrimary3UnitLtvOver75, this.MTGDU15_RateTermInvestment1UnitLtvOver75, this.MTGDU15_RateTermInvestment2UnitLtvOver75,
      this.MTGDU15_CashOutPrimaryPudLtvOver80, this.MTGDU15_CashOutPrimary4UnitLtvOver75, this.MTGDU15_CashOutSecondHomePudLtvOver75, this.MTGDU15_CashOutInvestmentPudLtvOver75, this.MTGDU15_CashOutInvestment3UnitLtvOver70,

      this.MTGDUA10_Standard, this.MTGDUA10_LoanLimitHigh, this.MTGDUA10_CondoSecondHomeSecondLoan, this.MTGDUA10_2UnitInvestment, this.MTGDUA10_4UnitCashOut,
      this.MTGDUA10_LtvMax97, this.MTGDUA10_LtvOverMax97, this.MTGDUA10_FicoMin620, this.MTGDUA10_FicoUnder619, this.MTGDUA10_DtiOver50,
      this.MTGDUA10_2UnitLtvOver95, this.MTGDUA10_4UnitLtvOver95, this.MTGDUA10_SecondHomeLtv90, this.MTGDUA10_SecondHomeLtvOver90, this.MTGDUA10_SecondHome2Unit, 
      this.MTGDUA10_InvestmentLtv80Fico620, this.MTGDUA10_InvestmentLtv85Fico620, this.MTGDUA10_InvestmentLtv85Fico680, this.MTGDUA10_Investment2UnitLtvOver75, this.MTGDUA10_Investment2UnitFico619,
      this.MTGDUA10_RateTermPrimarySfrLtv95, this.MTGDUA10_RateTermPrimary2UnitLtvOver85, this.MTGDUA10_RateTermPrimary3UnitLtvOver75, this.MTGDUA10_RateTermInvestment1UnitLtvOver75, this.MTGDUA10_RateTermInvestment2UnitLtvOver75,
      this.MTGDUA10_CashOutPrimaryPudLtvOver80, this.MTGDUA10_CashOutPrimary4UnitLtvOver75, this.MTGDUA10_CashOutSecondHomePudLtvOver75, this.MTGDUA10_CashOutInvestmentPudLtvOver75, this.MTGDUA10_CashOutInvestment3UnitLtvOver70,
  
      this.MTGDUA7_Standard, this.MTGDUA7_LoanLimitHigh, this.MTGDUA7_CondoSecondHomeSecondLoan, this.MTGDUA7_2UnitInvestment, this.MTGDUA7_4UnitCashOut,
      this.MTGDUA7_LtvMax97, this.MTGDUA7_LtvOverMax97, this.MTGDUA7_FicoMin620, this.MTGDUA7_FicoUnder619, this.MTGDUA7_DtiOver50,
      this.MTGDUA7_2UnitLtvOver95, this.MTGDUA7_4UnitLtvOver95, this.MTGDUA7_SecondHomeLtv90, this.MTGDUA7_SecondHomeLtvOver90, this.MTGDUA7_SecondHome2Unit, 
      this.MTGDUA7_InvestmentLtv80Fico620, this.MTGDUA7_InvestmentLtv85Fico620, this.MTGDUA7_InvestmentLtv85Fico680, this.MTGDUA7_Investment2UnitLtvOver75, this.MTGDUA7_Investment2UnitFico619,
      this.MTGDUA7_RateTermPrimarySfrLtv95, this.MTGDUA7_RateTermPrimary2UnitLtvOver85, this.MTGDUA7_RateTermPrimary3UnitLtvOver75, this.MTGDUA7_RateTermInvestment1UnitLtvOver75, this.MTGDUA7_RateTermInvestment2UnitLtvOver75,
      this.MTGDUA7_CashOutPrimaryPudLtvOver80, this.MTGDUA7_CashOutPrimary4UnitLtvOver75, this.MTGDUA7_CashOutSecondHomePudLtvOver75, this.MTGDUA7_CashOutInvestmentPudLtvOver75, this.MTGDUA7_CashOutInvestment3UnitLtvOver70,

      this.MTGLP30_Standard, this.MTGLP30_LoanLimitHigh, this.MTGLP30_CondoSecondHomeSecondLoan, this.MTGLP30_2UnitInvestment, this.MTGLP30_4UnitCashOut,
      this.MTGLP30_LtvMax97, this.MTGLP30_LtvOverMax97, this.MTGLP30_FicoMin620, this.MTGLP30_FicoUnder619, this.MTGLP30_DtiOver50,
      this.MTGLP30_2UnitLtvOver85, this.MTGLP30_4UnitLtvOver80, this.MTGLP30_SecondHomeLtv90, this.MTGLP30_SecondHomeLtvOver90, this.MTGLP30_SecondHome2Unit, 
      this.MTGLP30_InvestmentLtv80Fico620, this.MTGLP30_InvestmentLtv85Fico620, this.MTGLP30_InvestmentLtv85Fico680, this.MTGLP30_Investment2UnitLtvOver75, this.MTGLP30_Investment2UnitFico619,
      this.MTGLP30_RateTermPrimarySfrLtv97, this.MTGLP30_RateTermPrimary2UnitLtvOver85, this.MTGLP30_RateTermPrimary3UnitLtvOver75, this.MTGLP30_RateTermInvestment1UnitLtvOver75, this.MTGLP30_RateTermInvestment2UnitLtvOver75,
      this.MTGLP30_CashOutPrimaryPudLtvOver80, this.MTGLP30_CashOutPrimary4UnitLtvOver75, this.MTGLP30_CashOutSecondHomePudLtvOver75, this.MTGLP30_CashOutInvestmentPudLtvOver75, this.MTGLP30_CashOutInvestment3UnitLtvOver70,

      this.MTGLP15_Standard, this.MTGLP15_LoanLimitHigh, this.MTGLP15_CondoSecondHomeSecondLoan, this.MTGLP15_2UnitInvestment, this.MTGLP15_4UnitCashOut,
      this.MTGLP15_LtvMax97, this.MTGLP15_LtvOverMax97, this.MTGLP15_FicoMin620, this.MTGLP15_FicoUnder619, this.MTGLP15_DtiOver50,
      this.MTGLP15_2UnitLtvOver85, this.MTGLP15_4UnitLtvOver80, this.MTGLP15_SecondHomeLtv90, this.MTGLP15_SecondHomeLtvOver90, this.MTGLP15_SecondHome2Unit, 
      this.MTGLP15_InvestmentLtv80Fico620, this.MTGLP15_InvestmentLtv85Fico620, this.MTGLP15_InvestmentLtv85Fico680, this.MTGLP15_Investment2UnitLtvOver75, this.MTGLP15_Investment2UnitFico619,
      this.MTGLP15_RateTermPrimarySfrLtv97, this.MTGLP15_RateTermPrimary2UnitLtvOver85, this.MTGLP15_RateTermPrimary3UnitLtvOver75, this.MTGLP15_RateTermInvestment1UnitLtvOver75, this.MTGLP15_RateTermInvestment2UnitLtvOver75,
      this.MTGLP15_CashOutPrimaryPudLtvOver80, this.MTGLP15_CashOutPrimary4UnitLtvOver75, this.MTGLP15_CashOutSecondHomePudLtvOver75, this.MTGLP15_CashOutInvestmentPudLtvOver75, this.MTGLP15_CashOutInvestment3UnitLtvOver70,

      this.MTGLPA10_Standard, this.MTGLPA10_LoanLimitHigh, this.MTGLPA10_CondoSecondHomeSecondLoan, this.MTGLPA10_2UnitInvestment, this.MTGLPA10_4UnitCashOut,
      this.MTGLPA10_LtvMax95, this.MTGLPA10_LtvOverMax95, this.MTGLPA10_FicoMin620, this.MTGLPA10_FicoUnder619, this.MTGLPA10_DtiOver50,
      this.MTGLPA10_2UnitLtvOver85, this.MTGLPA10_4UnitLtvOver80, this.MTGLPA10_SecondHomeLtv90, this.MTGLPA10_SecondHomeLtvOver90, this.MTGLPA10_SecondHome2Unit, 
      this.MTGLPA10_InvestmentLtv80Fico620, this.MTGLPA10_InvestmentLtv85Fico620, this.MTGLPA10_InvestmentLtv85Fico680, this.MTGLPA10_Investment2UnitLtvOver75, this.MTGLPA10_Investment2UnitFico619,
      this.MTGLPA10_RateTermPrimarySfrLtv95, this.MTGLPA10_RateTermPrimary2UnitLtvOver85, this.MTGLPA10_RateTermPrimary3UnitLtvOver75, this.MTGLPA10_RateTermInvestment1UnitLtvOver75, this.MTGLPA10_RateTermInvestment2UnitLtvOver75,
      this.MTGLPA10_CashOutPrimaryPudLtvOver80, this.MTGLPA10_CashOutPrimary4UnitLtvOver75, this.MTGLPA10_CashOutSecondHomePudLtvOver75, this.MTGLPA10_CashOutInvestmentPudLtvOver75, this.MTGLPA10_CashOutInvestment3UnitLtvOver70,

      this.MTGLPA7_Standard, this.MTGLPA7_LoanLimitHigh, this.MTGLPA7_CondoSecondHomeSecondLoan, this.MTGLPA7_2UnitInvestment, this.MTGLPA7_4UnitCashOut,
      this.MTGLPA7_LtvMax95, this.MTGLPA7_LtvOverMax95, this.MTGLPA7_FicoMin620, this.MTGLPA7_FicoUnder619, this.MTGLPA7_DtiOver50,
      this.MTGLPA7_2UnitLtvOver85, this.MTGLPA7_4UnitLtvOver80, this.MTGLPA7_SecondHomeLtv90, this.MTGLPA7_SecondHomeLtvOver90, this.MTGLPA7_SecondHome2Unit, 
      this.MTGLPA7_InvestmentLtv80Fico620, this.MTGLPA7_InvestmentLtv85Fico620, this.MTGLPA7_InvestmentLtv85Fico680, this.MTGLPA7_Investment2UnitLtvOver75, this.MTGLPA7_Investment2UnitFico619,
      this.MTGLPA7_RateTermPrimarySfrLtv95, this.MTGLPA7_RateTermPrimary2UnitLtvOver85, this.MTGLPA7_RateTermPrimary3UnitLtvOver75, this.MTGLPA7_RateTermInvestment1UnitLtvOver75, this.MTGLPA7_RateTermInvestment2UnitLtvOver75,
      this.MTGLPA7_CashOutPrimaryPudLtvOver80, this.MTGLPA7_CashOutPrimary4UnitLtvOver75, this.MTGLPA7_CashOutSecondHomePudLtvOver75, this.MTGLPA7_CashOutInvestmentPudLtvOver75, this.MTGLPA7_CashOutInvestment3UnitLtvOver70,

      // jumbo

      // portfolio 1

      // portfolio 2

      // ...
    ];
    this.setState({ testRunning: true, abortTest: false, testStatus: 'Starting Unit Tests', passCount: 0, failCount: 0, errorLog: [] });

    for(var i=0; i<unitTestArray.length; i++) {
      if(this.state.abortTest)
        break;
      this.setState({testStatus: 'Running Test #' + (i+1) + ' of ' + unitTestArray.length + ' - ' + unitTestArray[i].toString().substring(6).split('()')[0]})
      var result = await unitTestArray[i]();
      if(!result.toString().startsWith('Error'))
        this.setState({passCount: this.state.passCount + 1});
      else {
        this.state.errorLog.push('Test #' + (i+1) + ' - ' + unitTestArray[i].toString().substring(6).split('()')[0] + '\n' + result.toString().substring(7))
        this.setState({
          failCount: this.state.failCount + 1,
          errorLog: this.state.errorLog
        });
      }
    }
    this.setState({ testStatus: this.state.abortTest ? 'Unit Tests Canceled!' : 'Unit Tests Complete!', testRunning: false });
  }

  // standard MTGDU30 parameters that should have no errors
  async MTGDU30_Standard() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '65', pCltv: '65', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDU30 with loan amount exceeding allowed
  async MTGDU30_LoanLimitHigh() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '850000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '65', pCltv: '65', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Success"; } // no progams should be returned
      else { return "Error: No Programs Should Have Been Returned"; }
    }
  }

  // MTGDU30 adjustments Condo, Second Home, Second Loan
  async MTGDU30_CondoSecondHomeSecondLoan() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '100000', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'Condo (Attached)', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '50', pCltv: '60', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { 
        if(!programs[0].priceAdjustments || programs[0].priceAdjustments.length !== 4) { return "Error: Expected Price Adjustments Not Returned"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'MTGDU30 LLPA')) { return "Error: Price Adjusment Missing (MTGDU30 LLPA)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Condo')) { return "Error: Price Adjusment Missing (Condo)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Second Home')) { return "Error: Price Adjusment Missing (Second Home)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Subordinate Financing')) { return "Error: Price Adjusment Missing (Subordinate Financing)"; }
        return "Success"; 
      }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDU30 adjustments 2 Unit, Investment
  async MTGDU30_2UnitInvestment() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { 
        if(!programs[0].priceAdjustments || programs[0].priceAdjustments.length !== 3) { return "Error: Expected Price Adjustments Not Returned"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'MTGDU30 LLPA')) { return "Error: Price Adjusment Missing (MTGDU30 LLPA)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, '2 to 4 Unit')) { return "Error: Price Adjusment Missing (2 to 4 Unit)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Investment Property')) { return "Error: Price Adjusment Missing (Investment Property)"; }
        return "Success"; 
      }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDU30 adjustments 4 Unit, C/O
  async MTGDU30_4UnitCashOut() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: '4 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { 
        if(!programs[0].priceAdjustments || programs[0].priceAdjustments.length !== 2) { return "Error: Expected Price Adjustments Not Returned"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'MTGDU30 LLPA')) { return "Error: Price Adjusment Missing (MTGDU30 LLPA)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, '2 to 4 Unit')) { return "Error: Price Adjusment Missing (2 to 4 Unit)"; }
        return "Success"; 
      }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDU30 with ltv at maximum of 97
  async MTGDU30_LtvMax97() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '97', pCltv: '97', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDU30 with ltv just over maximum at 97.01
  async MTGDU30_LtvOverMax97() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '97.01', pCltv: '97.01', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU30 with fico at minimum of 620
  async MTGDU30_FicoMin620() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '620',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDU30 with ltv just under minimum at 619
  async MTGDU30_FicoUnder619() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '619',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Low FICO Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU30 with dti just over maximum at 50.01
  async MTGDU30_DtiOver50() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '780',
        pDtiFront: '45', pDtiBack: '50.01',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding DTI Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU30 with ltv just over maximum at 95.01
  async MTGDU30_2UnitLtvOver95() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '95.01', pCltv: '95.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU30 with ltv just over maximum at 95.01
  async MTGDU30_4UnitLtvOver95() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '4 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '95.01', pCltv: '95.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU30 with 2nd home ltv at 90
  async MTGDU30_SecondHomeLtv90() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '90', pCltv: '90', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }
  
  // MTGDU30 with 2nd home ltv just over maximum at 90.01
  async MTGDU30_SecondHomeLtvOver90() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '90.01', pCltv: '90.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU30 with 2nd home with 2 units
  async MTGDU30_SecondHome2Unit() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '80', pCltv: '80', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Multi-Unit Second Home Not Supported"; }
      else { return "Success" };
    }
  }
  
  // MTGDU30 with investment ltv 80 fico 620
  async MTGDU30_InvestmentLtv80Fico620() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'Condo (Detached)', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '80', pCltv: '80', pFico: '620',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDU30 with investment ltv 85 fico 620
  async MTGDU30_InvestmentLtv85Fico620() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '85', pCltv: '85', pFico: '620',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Low FICO Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU30 with investment ltv 85 fico 680
  async MTGDU30_InvestmentLtv85Fico680() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'Condo (Detached)', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '85', pCltv: '85', pFico: '680',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDU30 with investment 2 unit ltv over 75
  async MTGDU30_Investment2UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '620',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU30 with investment 2 unit fico under 620
  async MTGDU30_Investment2UnitFico619() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75', pCltv: '75', pFico: '619',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Low FICO Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU30 with R/T, 1 Unit, LTV 97
  async MTGDU30_RateTermPrimarySfrLtv97() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '97', pCltv: '97', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDU30 with R/T, 2 Unit, LTV 85.01
  async MTGDU30_RateTermPrimary2UnitLtvOver85() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '85.01', pCltv: '85.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU30 with R/T, 3 Unit, LTV 75.01
  async MTGDU30_RateTermPrimary3UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: '3 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU30 with R/T, Investment, 1 Unit, LTV 75.01
  async MTGDU30_RateTermInvestment1UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU30 with R/T, Investment, 2 Unit, LTV 75.01
  async MTGDU30_RateTermInvestment2UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '85.01', pCltv: '85.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU30 with C/O, 1 Unit, LTV 80.01
  async MTGDU30_CashOutPrimaryPudLtvOver80() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '80.01', pCltv: '80.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU30 with C/O, 4 Unit, LTV 75.01
  async MTGDU30_CashOutPrimary4UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: '4 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU30 with C/O, 2nd Home, 1 Unit, LTV 75.01
  async MTGDU30_CashOutSecondHomePudLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU30 with C/O, Investment, 1 Unit, LTV 75.01
  async MTGDU30_CashOutInvestmentPudLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU30 with C/O, Investment, 3 Unit, LTV 70.01
  async MTGDU30_CashOutInvestment3UnitLtvOver70() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: '3 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '70.01', pCltv: '70.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // standard MTGDU15 parameters that should have no errors
  async MTGDU15_Standard() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '65', pCltv: '65', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDU15 with loan amount exceeding allowed
  async MTGDU15_LoanLimitHigh() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '850000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '65', pCltv: '65', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Success"; } // no progams should be returned
      else { return "Error: No Programs Should Have Been Returned"; }
    }
  }

  // MTGDU15 adjustments Condo, Second Home, Second Loan
  async MTGDU15_CondoSecondHomeSecondLoan() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '100000', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'Condo (Attached)', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '50', pCltv: '60', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { 
        if(!programs[0].priceAdjustments || programs[0].priceAdjustments.length !== 3) { return "Error: Expected Price Adjustments Not Returned"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Condo')) { return "Error: Price Adjusment Missing (Condo)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Second Home')) { return "Error: Price Adjusment Missing (Second Home)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Subordinate Financing')) { return "Error: Price Adjusment Missing (Subordinate Financing)"; }
        return "Success"; 
      }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDU15 adjustments 2 Unit, Investment
  async MTGDU15_2UnitInvestment() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { 
        if(!programs[0].priceAdjustments || programs[0].priceAdjustments.length !== 2) { return "Error: Expected Price Adjustments Not Returned"; }
        if(!itemInAdjList(programs[0].priceAdjustments, '2 to 4 Unit')) { return "Error: Price Adjusment Missing (2 to 4 Unit)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Investment Property')) { return "Error: Price Adjusment Missing (Investment Property)"; }
        return "Success"; 
      }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDU15 adjustments 4 Unit, C/O
  async MTGDU15_4UnitCashOut() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: '4 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) {
        if(!programs[0].priceAdjustments || programs[0].priceAdjustments.length !== 2) { return "Error: Expected Price Adjustments Not Returned"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'MTGDU15 LLPA')) { return "Error: Price Adjusment Missing (MTGDU15 LLPA)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, '2 to 4 Unit')) { return "Error: Price Adjusment Missing (2 to 4 Unit)"; }
        return "Success"; 
      }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDU15 with ltv at maximum of 97
  async MTGDU15_LtvMax97() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '97', pCltv: '97', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDU15 with ltv just over maximum at 97.01
  async MTGDU15_LtvOverMax97() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '97.01', pCltv: '97.01', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU15 with fico at minimum of 620
  async MTGDU15_FicoMin620() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '620',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDU15 with ltv just under minimum at 619
  async MTGDU15_FicoUnder619() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '619',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Low FICO Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU15 with dti just over maximum at 50.01
  async MTGDU15_DtiOver50() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '780',
        pDtiFront: '45', pDtiBack: '50.01',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding DTI Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU15 with ltv just over maximum at 95.01
  async MTGDU15_2UnitLtvOver95() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '95.01', pCltv: '95.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU15 with ltv just over maximum at 95.01
  async MTGDU15_4UnitLtvOver95() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '4 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '95.01', pCltv: '95.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU15 with 2nd home ltv at 90
  async MTGDU15_SecondHomeLtv90() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '90', pCltv: '90', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDU15 with 2nd home ltv just over maximum at 90.01
  async MTGDU15_SecondHomeLtvOver90() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '90.01', pCltv: '90.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU15 with 2nd home with 2 units
  async MTGDU15_SecondHome2Unit() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '80', pCltv: '80', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Multi-Unit Second Home Not Supported"; }
      else { return "Success" };
    }
  }

  // MTGDU15 with investment ltv 80 fico 620
  async MTGDU15_InvestmentLtv80Fico620() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'Condo (Detached)', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '80', pCltv: '80', pFico: '620',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDU15 with investment ltv 85 fico 620
  async MTGDU15_InvestmentLtv85Fico620() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '85', pCltv: '85', pFico: '620',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Low FICO Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU15 with investment ltv 85 fico 680
  async MTGDU15_InvestmentLtv85Fico680() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'Condo (Detached)', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '85', pCltv: '85', pFico: '680',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDU15 with investment 2 unit ltv over 75
  async MTGDU15_Investment2UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '620',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU15 with investment 2 unit fico under 620
  async MTGDU15_Investment2UnitFico619() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75', pCltv: '75', pFico: '619',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Low FICO Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU15 with R/T, 1 Unit, LTV 97
  async MTGDU15_RateTermPrimarySfrLtv97() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '97', pCltv: '97', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDU15 with R/T, 2 Unit, LTV 85.01
  async MTGDU15_RateTermPrimary2UnitLtvOver85() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '85.01', pCltv: '85.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU15 with R/T, 3 Unit, LTV 75.01
  async MTGDU15_RateTermPrimary3UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: '3 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU15 with R/T, Investment, 1 Unit, LTV 75.01
  async MTGDU15_RateTermInvestment1UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU15 with R/T, Investment, 2 Unit, LTV 75.01
  async MTGDU15_RateTermInvestment2UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '85.01', pCltv: '85.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU15 with C/O, 1 Unit, LTV 80.01
  async MTGDU15_CashOutPrimaryPudLtvOver80() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '80.01', pCltv: '80.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU15 with C/O, 4 Unit, LTV 75.01
  async MTGDU15_CashOutPrimary4UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: '4 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU15 with C/O, 2nd Home, 1 Unit, LTV 75.01
  async MTGDU15_CashOutSecondHomePudLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU15 with C/O, Investment, 1 Unit, LTV 75.01
  async MTGDU15_CashOutInvestmentPudLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDU15 with C/O, Investment, 3 Unit, LTV 70.01
  async MTGDU15_CashOutInvestment3UnitLtvOver70() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDU15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: '3 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '70.01', pCltv: '70.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // standard MTGDUA10 parameters that should have no errors
  async MTGDUA10_Standard() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '65', pCltv: '65', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDUA10 with loan amount exceeding allowed
  async MTGDUA10_LoanLimitHigh() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '850000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '65', pCltv: '65', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Success"; } // no progams should be returned
      else { return "Error: No Programs Should Have Been Returned"; }
    }
  }

  // MTGDUA10 adjustments Condo, Second Home, Second Loan
  async MTGDUA10_CondoSecondHomeSecondLoan() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '100000', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'Condo (Attached)', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '50', pCltv: '60', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) {
        if(!programs[0].priceAdjustments || programs[0].priceAdjustments.length !== 4) { return "Error: Expected Price Adjustments Not Returned"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'ARM')) { return "Error: Price Adjusment Missing (ARM)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Condo')) { return "Error: Price Adjusment Missing (Condo)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Second Home')) { return "Error: Price Adjusment Missing (Second Home)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Subordinate Financing')) { return "Error: Price Adjusment Missing (Subordinate Financing)"; }
        return "Success"; 
      }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDUA10 adjustments 2 Unit, Investment
  async MTGDUA10_2UnitInvestment() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { 
        if(!programs[0].priceAdjustments || programs[0].priceAdjustments.length !== 3) { return "Error: Expected Price Adjustments Not Returned"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'ARM')) { return "Error: Price Adjusment Missing (ARM)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, '2 to 4 Unit')) { return "Error: Price Adjusment Missing (2 to 4 Unit)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Investment Property')) { return "Error: Price Adjusment Missing (Investment Property)"; }
        return "Success"; 
      }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDUA10 adjustments 4 Unit, C/O
  async MTGDUA10_4UnitCashOut() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: '4 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { 
        if(!programs[0].priceAdjustments || programs[0].priceAdjustments.length !== 3) { return "Error: Expected Price Adjustments Not Returned"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'MTGDUA10 LLPA')) { return "Error: Price Adjusment Missing (MTGDUA10 LLPA)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'ARM')) { return "Error: Price Adjusment Missing (ARM)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, '2 to 4 Unit')) { return "Error: Price Adjusment Missing (2 to 4 Unit)"; }
        return "Success"; 
      }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDUA10 with ltv at maximum of 97
  async MTGDUA10_LtvMax97() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '97', pCltv: '97', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDUA10 with ltv just over maximum at 97.01
  async MTGDUA10_LtvOverMax97() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '97.01', pCltv: '97.01', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA10 with fico at minimum of 620
  async MTGDUA10_FicoMin620() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '620',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDUA10 with ltv just under minimum at 619
  async MTGDUA10_FicoUnder619() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '619',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Low FICO Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA10 with dti just over maximum at 50.01
  async MTGDUA10_DtiOver50() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '780',
        pDtiFront: '45', pDtiBack: '50.01',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding DTI Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA10 with ltv just over maximum at 95.01
  async MTGDUA10_2UnitLtvOver95() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '95.01', pCltv: '95.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA10 with ltv just over maximum at 95.01
  async MTGDUA10_4UnitLtvOver95() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '4 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '95.01', pCltv: '95.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA10 with 2nd home ltv at 90
  async MTGDUA10_SecondHomeLtv90() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '90', pCltv: '90', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDUA10 with 2nd home ltv just over maximum at 90.01
  async MTGDUA10_SecondHomeLtvOver90() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '90.01', pCltv: '90.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA10 with 2nd home with 2 units
  async MTGDUA10_SecondHome2Unit() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '80', pCltv: '80', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Multi-Unit Second Home Not Supported"; }
      else { return "Success" };
    }
  }

  // MTGDUA10 with investment ltv 80 fico 620
  async MTGDUA10_InvestmentLtv80Fico620() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'Condo (Detached)', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '80', pCltv: '80', pFico: '620',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDUA10 with investment ltv 85 fico 620
  async MTGDUA10_InvestmentLtv85Fico620() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '85', pCltv: '85', pFico: '620',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Low FICO Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA10 with investment ltv 85 fico 680
  async MTGDUA10_InvestmentLtv85Fico680() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'Condo (Detached)', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '85', pCltv: '85', pFico: '680',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDUA10 with investment 2 unit ltv over 75
  async MTGDUA10_Investment2UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '620',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA10 with investment 2 unit fico under 620
  async MTGDUA10_Investment2UnitFico619() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75', pCltv: '75', pFico: '619',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Low FICO Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA10 with R/T, 1 Unit, LTV 95
  async MTGDUA10_RateTermPrimarySfrLtv95() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '95', pCltv: '95', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDUA10 with R/T, 2 Unit, LTV 85.01
  async MTGDUA10_RateTermPrimary2UnitLtvOver85() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '85.01', pCltv: '85.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA10 with R/T, 3 Unit, LTV 75.01
  async MTGDUA10_RateTermPrimary3UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: '3 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA10 with R/T, Investment, 1 Unit, LTV 75.01
  async MTGDUA10_RateTermInvestment1UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA10 with R/T, Investment, 2 Unit, LTV 75.01
  async MTGDUA10_RateTermInvestment2UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '85.01', pCltv: '85.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA10 with C/O, 1 Unit, LTV 80.01
  async MTGDUA10_CashOutPrimaryPudLtvOver80() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '80.01', pCltv: '80.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA10 with C/O, 4 Unit, LTV 75.01
  async MTGDUA10_CashOutPrimary4UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: '4 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA10 with C/O, 2nd Home, 1 Unit, LTV 75.01
  async MTGDUA10_CashOutSecondHomePudLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA10 with C/O, Investment, 1 Unit, LTV 75.01
  async MTGDUA10_CashOutInvestmentPudLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA10 with C/O, Investment, 3 Unit, LTV 70.01
  async MTGDUA10_CashOutInvestment3UnitLtvOver70() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: '3 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '70.01', pCltv: '70.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // standard MTGDUA7 parameters that should have no errors
  async MTGDUA7_Standard() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '65', pCltv: '65', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDUA7 with loan amount exceeding allowed
  async MTGDUA7_LoanLimitHigh() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '850000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '65', pCltv: '65', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Success"; } // no progams should be returned
      else { return "Error: No Programs Should Have Been Returned"; }
    }
  }

  // MTGDUA7 adjustments Condo, Second Home, Second Loan
  async MTGDUA7_CondoSecondHomeSecondLoan() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '100000', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'Condo (Attached)', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '50', pCltv: '60', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) {
        if(!programs[0].priceAdjustments || programs[0].priceAdjustments.length !== 4) { return "Error: Expected Price Adjustments Not Returned"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'ARM')) { return "Error: Price Adjusment Missing (ARM)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Condo')) { return "Error: Price Adjusment Missing (Condo)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Second Home')) { return "Error: Price Adjusment Missing (Second Home)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Subordinate Financing')) { return "Error: Price Adjusment Missing (Subordinate Financing)"; }
        return "Success"; 
      }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDUA7 adjustments 2 Unit, Investment
  async MTGDUA7_2UnitInvestment() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { 
        if(!programs[0].priceAdjustments || programs[0].priceAdjustments.length !== 3) { return "Error: Expected Price Adjustments Not Returned"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'ARM')) { return "Error: Price Adjusment Missing (ARM)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, '2 to 4 Unit')) { return "Error: Price Adjusment Missing (2 to 4 Unit)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Investment Property')) { return "Error: Price Adjusment Missing (Investment Property)"; }
        return "Success"; 
      }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDUA7 adjustments 4 Unit, C/O
  async MTGDUA7_4UnitCashOut() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: '4 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { 
        if(!programs[0].priceAdjustments || programs[0].priceAdjustments.length !== 3) { return "Error: Expected Price Adjustments Not Returned"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'MTGDUA7 LLPA')) { return "Error: Price Adjusment Missing (MTGDUA7 LLPA)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'ARM')) { return "Error: Price Adjusment Missing (ARM)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, '2 to 4 Unit')) { return "Error: Price Adjusment Missing (2 to 4 Unit)"; }
        return "Success"; 
      }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDUA7 with ltv at maximum of 97
  async MTGDUA7_LtvMax97() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '97', pCltv: '97', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDUA7 with ltv just over maximum at 97.01
  async MTGDUA7_LtvOverMax97() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '97.01', pCltv: '97.01', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA7 with fico at minimum of 620
  async MTGDUA7_FicoMin620() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '620',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDUA7 with ltv just under minimum at 619
  async MTGDUA7_FicoUnder619() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '619',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Low FICO Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA7 with dti just over maximum at 50.01
  async MTGDUA7_DtiOver50() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '780',
        pDtiFront: '45', pDtiBack: '50.01',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding DTI Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA7 with ltv just over maximum at 95.01
  async MTGDUA7_2UnitLtvOver95() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '95.01', pCltv: '95.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA7 with ltv just over maximum at 95.01
  async MTGDUA7_4UnitLtvOver95() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '4 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '95.01', pCltv: '95.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA7 with 2nd home ltv at 90
  async MTGDUA7_SecondHomeLtv90() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '90', pCltv: '90', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDUA7 with 2nd home ltv just over maximum at 90.01
  async MTGDUA7_SecondHomeLtvOver90() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '90.01', pCltv: '90.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA7 with 2nd home with 2 units
  async MTGDUA7_SecondHome2Unit() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '80', pCltv: '80', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Multi-Unit Second Home Not Supported"; }
      else { return "Success" };
    }
  }

  // MTGDUA7 with investment ltv 80 fico 620
  async MTGDUA7_InvestmentLtv80Fico620() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'Condo (Detached)', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '80', pCltv: '80', pFico: '620',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDUA7 with investment ltv 85 fico 620
  async MTGDUA7_InvestmentLtv85Fico620() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '85', pCltv: '85', pFico: '620',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Low FICO Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA7 with investment ltv 85 fico 680
  async MTGDUA7_InvestmentLtv85Fico680() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'Condo (Detached)', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '85', pCltv: '85', pFico: '680',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDUA7 with investment 2 unit ltv over 75
  async MTGDUA7_Investment2UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '620',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA7 with investment 2 unit fico under 620
  async MTGDUA7_Investment2UnitFico619() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75', pCltv: '75', pFico: '619',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Low FICO Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA7 with R/T, 1 Unit, LTV 95
  async MTGDUA7_RateTermPrimarySfrLtv95() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '95', pCltv: '95', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGDUA7 with R/T, 2 Unit, LTV 85.01
  async MTGDUA7_RateTermPrimary2UnitLtvOver85() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '85.01', pCltv: '85.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA7 with R/T, 3 Unit, LTV 75.01
  async MTGDUA7_RateTermPrimary3UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: '3 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA7 with R/T, Investment, 1 Unit, LTV 75.01
  async MTGDUA7_RateTermInvestment1UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA7 with R/T, Investment, 2 Unit, LTV 75.01
  async MTGDUA7_RateTermInvestment2UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '85.01', pCltv: '85.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA7 with C/O, 1 Unit, LTV 80.01
  async MTGDUA7_CashOutPrimaryPudLtvOver80() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '80.01', pCltv: '80.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA7 with C/O, 4 Unit, LTV 75.01
  async MTGDUA7_CashOutPrimary4UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: '4 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA7 with C/O, 2nd Home, 1 Unit, LTV 75.01
  async MTGDUA7_CashOutSecondHomePudLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA7 with C/O, Investment, 1 Unit, LTV 75.01
  async MTGDUA7_CashOutInvestmentPudLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGDUA7 with C/O, Investment, 3 Unit, LTV 70.01
  async MTGDUA7_CashOutInvestment3UnitLtvOver70() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGDUA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: '3 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '70.01', pCltv: '70.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // standard MTGLP30 parameters that should have no errors
  async MTGLP30_Standard() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '65', pCltv: '65', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLP30 with loan amount exceeding allowed
  async MTGLP30_LoanLimitHigh() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '850000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '65', pCltv: '65', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Success"; } // no progams should be returned
      else { return "Error: No Programs Should Have Been Returned"; }
    }
  }

  // MTGLP30 adjustments Condo, Second Home, Second Loan
  async MTGLP30_CondoSecondHomeSecondLoan() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '100000', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'Condo (Attached)', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '50', pCltv: '60', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { 
        if(!programs[0].priceAdjustments || programs[0].priceAdjustments.length !== 4) { return "Error: Expected Price Adjustments Not Returned"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'MTGLP30 LLPA')) { return "Error: Price Adjusment Missing (MTGLP30 LLPA)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Condo')) { return "Error: Price Adjusment Missing (Condo)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Second Home')) { return "Error: Price Adjusment Missing (Second Home)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Subordinate Financing')) { return "Error: Price Adjusment Missing (Subordinate Financing)"; }
        return "Success"; 
      }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLP30 adjustments 2 Unit, Investment
  async MTGLP30_2UnitInvestment() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { 
        if(!programs[0].priceAdjustments || programs[0].priceAdjustments.length !== 3) { return "Error: Expected Price Adjustments Not Returned"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'MTGLP30 LLPA')) { return "Error: Price Adjusment Missing (MTGLP30 LLPA)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, '2 to 4 Unit')) { return "Error: Price Adjusment Missing (2 to 4 Unit)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Investment Property')) { return "Error: Price Adjusment Missing (Investment Property)"; }
        return "Success"; 
      }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLP30 adjustments 4 Unit, C/O
  async MTGLP30_4UnitCashOut() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: '4 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { 
        if(!programs[0].priceAdjustments || programs[0].priceAdjustments.length !== 2) { return "Error: Expected Price Adjustments Not Returned"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'MTGLP30 LLPA')) { return "Error: Price Adjusment Missing (MTGLP30 LLPA)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, '2 to 4 Unit')) { return "Error: Price Adjusment Missing (2 to 4 Unit)"; }
        return "Success"; 
      }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLP30 with ltv at maximum of 97
  async MTGLP30_LtvMax97() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '97', pCltv: '97', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLP30 with ltv just over maximum at 97.01
  async MTGLP30_LtvOverMax97() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '97.01', pCltv: '97.01', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP30 with fico at minimum of 620
  async MTGLP30_FicoMin620() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '620',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLP30 with ltv just under minimum at 619
  async MTGLP30_FicoUnder619() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '619',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Low FICO Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP30 with dti just over maximum at 50.01
  async MTGLP30_DtiOver50() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '780',
        pDtiFront: '45', pDtiBack: '50.01',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding DTI Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP30 with ltv just over maximum at 85.01
  async MTGLP30_2UnitLtvOver85() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '85.01', pCltv: '85.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP30 with ltv just over maximum at 80.01
  async MTGLP30_4UnitLtvOver80() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '4 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '80.01', pCltv: '80.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP30 with 2nd home ltv at 90
  async MTGLP30_SecondHomeLtv90() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '90', pCltv: '90', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLP30 with 2nd home ltv just over maximum at 90.01
  async MTGLP30_SecondHomeLtvOver90() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '90.01', pCltv: '90.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP30 with 2nd home with 2 units
  async MTGLP30_SecondHome2Unit() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '80', pCltv: '80', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Multi-Unit Second Home Not Supported"; }
      else { return "Success" };
    }
  }

  // MTGLP30 with investment ltv 80 fico 620
  async MTGLP30_InvestmentLtv80Fico620() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'Condo (Detached)', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '80', pCltv: '80', pFico: '620',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLP30 with investment ltv 85 fico 620
  async MTGLP30_InvestmentLtv85Fico620() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '85', pCltv: '85', pFico: '620',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Low FICO Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP30 with investment ltv 85 fico 680
  async MTGLP30_InvestmentLtv85Fico680() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'Condo (Detached)', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '85', pCltv: '85', pFico: '680',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLP30 with investment 2 unit ltv over 75
  async MTGLP30_Investment2UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '620',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP30 with investment 2 unit fico under 620
  async MTGLP30_Investment2UnitFico619() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75', pCltv: '75', pFico: '619',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Low FICO Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP30 with R/T, 1 Unit, LTV 97
  async MTGLP30_RateTermPrimarySfrLtv97() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '97', pCltv: '97', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLP30 with R/T, 2 Unit, LTV 85.01
  async MTGLP30_RateTermPrimary2UnitLtvOver85() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '85.01', pCltv: '85.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP30 with R/T, 3 Unit, LTV 75.01
  async MTGLP30_RateTermPrimary3UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: '3 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLP30 with R/T, Investment, 1 Unit, LTV 75.01
  async MTGLP30_RateTermInvestment1UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLP30 with R/T, Investment, 2 Unit, LTV 75.01
  async MTGLP30_RateTermInvestment2UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '85.01', pCltv: '85.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP30 with C/O, 1 Unit, LTV 80.01
  async MTGLP30_CashOutPrimaryPudLtvOver80() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '80.01', pCltv: '80.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP30 with C/O, 4 Unit, LTV 75.01
  async MTGLP30_CashOutPrimary4UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: '4 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP30 with C/O, 2nd Home, 1 Unit, LTV 75.01
  async MTGLP30_CashOutSecondHomePudLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP30 with C/O, Investment, 1 Unit, LTV 75.01
  async MTGLP30_CashOutInvestmentPudLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP30 with C/O, Investment, 3 Unit, LTV 70.01
  async MTGLP30_CashOutInvestment3UnitLtvOver70() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP30', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: '3 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '70.01', pCltv: '70.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // standard MTGLP15 parameters that should have no errors
  async MTGLP15_Standard() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '65', pCltv: '65', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLP15 with loan amount exceeding allowed
  async MTGLP15_LoanLimitHigh() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '850000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '65', pCltv: '65', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Success"; } // no progams should be returned
      else { return "Error: No Programs Should Have Been Returned"; }
    }
  }

  // MTGLP15 adjustments Condo, Second Home, Second Loan
  async MTGLP15_CondoSecondHomeSecondLoan() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '100000', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'Condo (Attached)', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '50', pCltv: '60', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { 
        if(!programs[0].priceAdjustments || programs[0].priceAdjustments.length !== 3) { return "Error: Expected Price Adjustments Not Returned"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Condo')) { return "Error: Price Adjusment Missing (Condo)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Second Home')) { return "Error: Price Adjusment Missing (Second Home)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Subordinate Financing')) { return "Error: Price Adjusment Missing (Subordinate Financing)"; }
        return "Success"; 
      }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLP15 adjustments 2 Unit, Investment
  async MTGLP15_2UnitInvestment() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { 
        if(!programs[0].priceAdjustments || programs[0].priceAdjustments.length !== 2) { return "Error: Expected Price Adjustments Not Returned"; }
        if(!itemInAdjList(programs[0].priceAdjustments, '2 to 4 Unit')) { return "Error: Price Adjusment Missing (2 to 4 Unit)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Investment Property')) { return "Error: Price Adjusment Missing (Investment Property)"; }
        return "Success"; 
      }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLP15 adjustments 4 Unit, C/O
  async MTGLP15_4UnitCashOut() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: '4 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) {
        if(!programs[0].priceAdjustments || programs[0].priceAdjustments.length !== 2) { return "Error: Expected Price Adjustments Not Returned"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'MTGLP15 LLPA')) { return "Error: Price Adjusment Missing (MTGLP15 LLPA)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, '2 to 4 Unit')) { return "Error: Price Adjusment Missing (2 to 4 Unit)"; }
        return "Success"; 
      }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLP15 with ltv at maximum of 97
  async MTGLP15_LtvMax97() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '97', pCltv: '97', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLP15 with ltv just over maximum at 97.01
  async MTGLP15_LtvOverMax97() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '97.01', pCltv: '97.01', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP15 with fico at minimum of 620
  async MTGLP15_FicoMin620() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '620',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLP15 with ltv just under minimum at 619
  async MTGLP15_FicoUnder619() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '619',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Low FICO Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP15 with dti just over maximum at 50.01
  async MTGLP15_DtiOver50() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '780',
        pDtiFront: '45', pDtiBack: '50.01',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding DTI Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP15 with ltv just over maximum at 85.01
  async MTGLP15_2UnitLtvOver85() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '85.01', pCltv: '85.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP15 with ltv just over maximum at 80.01
  async MTGLP15_4UnitLtvOver80() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '4 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '80.01', pCltv: '80.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP15 with 2nd home ltv at 90
  async MTGLP15_SecondHomeLtv90() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '90', pCltv: '90', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLP15 with 2nd home ltv just over maximum at 90.01
  async MTGLP15_SecondHomeLtvOver90() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '90.01', pCltv: '90.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP15 with 2nd home with 2 units
  async MTGLP15_SecondHome2Unit() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '80', pCltv: '80', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Multi-Unit Second Home Not Supported"; }
      else { return "Success" };
    }
  }

  // MTGLP15 with investment ltv 80 fico 620
  async MTGLP15_InvestmentLtv80Fico620() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'Condo (Detached)', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '80', pCltv: '80', pFico: '620',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLP15 with investment ltv 85 fico 620
  async MTGLP15_InvestmentLtv85Fico620() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '85', pCltv: '85', pFico: '620',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Low FICO Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP15 with investment ltv 85 fico 680
  async MTGLP15_InvestmentLtv85Fico680() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'Condo (Detached)', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '85', pCltv: '85', pFico: '680',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLP15 with investment 2 unit ltv over 75
  async MTGLP15_Investment2UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '620',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP15 with investment 2 unit fico under 620
  async MTGLP15_Investment2UnitFico619() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75', pCltv: '75', pFico: '619',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Low FICO Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP15 with R/T, 1 Unit, LTV 97
  async MTGLP15_RateTermPrimarySfrLtv97() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '97', pCltv: '97', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLP15 with R/T, 2 Unit, LTV 85.01
  async MTGLP15_RateTermPrimary2UnitLtvOver85() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '85.01', pCltv: '85.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP15 with R/T, 3 Unit, LTV 75.01
  async MTGLP15_RateTermPrimary3UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: '3 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLP15 with R/T, Investment, 1 Unit, LTV 75.01
  async MTGLP15_RateTermInvestment1UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLP15 with R/T, Investment, 2 Unit, LTV 75.01
  async MTGLP15_RateTermInvestment2UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '85.01', pCltv: '85.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP15 with C/O, 1 Unit, LTV 80.01
  async MTGLP15_CashOutPrimaryPudLtvOver80() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '80.01', pCltv: '80.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP15 with C/O, 4 Unit, LTV 75.01
  async MTGLP15_CashOutPrimary4UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: '4 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP15 with C/O, 2nd Home, 1 Unit, LTV 75.01
  async MTGLP15_CashOutSecondHomePudLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP15 with C/O, Investment, 1 Unit, LTV 75.01
  async MTGLP15_CashOutInvestmentPudLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLP15 with C/O, Investment, 3 Unit, LTV 70.01
  async MTGLP15_CashOutInvestment3UnitLtvOver70() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLP15', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: '3 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '70.01', pCltv: '70.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // standard MTGLPA10 parameters that should have no errors
  async MTGLPA10_Standard() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '65', pCltv: '65', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLPA10 with loan amount exceeding allowed
  async MTGLPA10_LoanLimitHigh() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '850000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '65', pCltv: '65', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Success"; } // no progams should be returned
      else { return "Error: No Programs Should Have Been Returned"; }
    }
  }

  // MTGLPA10 adjustments Condo, Second Home, Second Loan
  async MTGLPA10_CondoSecondHomeSecondLoan() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '100000', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'Condo (Attached)', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '50', pCltv: '60', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) {
        if(!programs[0].priceAdjustments || programs[0].priceAdjustments.length !== 4) { return "Error: Expected Price Adjustments Not Returned"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'ARM')) { return "Error: Price Adjusment Missing (ARM)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Condo')) { return "Error: Price Adjusment Missing (Condo)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Second Home')) { return "Error: Price Adjusment Missing (Second Home)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Subordinate Financing')) { return "Error: Price Adjusment Missing (Subordinate Financing)"; }
        return "Success"; 
      }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLPA10 adjustments 2 Unit, Investment
  async MTGLPA10_2UnitInvestment() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { 
        if(!programs[0].priceAdjustments || programs[0].priceAdjustments.length !== 3) { return "Error: Expected Price Adjustments Not Returned"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'ARM')) { return "Error: Price Adjusment Missing (ARM)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, '2 to 4 Unit')) { return "Error: Price Adjusment Missing (2 to 4 Unit)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Investment Property')) { return "Error: Price Adjusment Missing (Investment Property)"; }
        return "Success"; 
      }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLPA10 adjustments 4 Unit, C/O
  async MTGLPA10_4UnitCashOut() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: '4 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { 
        if(!programs[0].priceAdjustments || programs[0].priceAdjustments.length !== 3) { return "Error: Expected Price Adjustments Not Returned"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'MTGLPA10 LLPA')) { return "Error: Price Adjusment Missing (MTGLPA10 LLPA)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'ARM')) { return "Error: Price Adjusment Missing (ARM)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, '2 to 4 Unit')) { return "Error: Price Adjusment Missing (2 to 4 Unit)"; }
        return "Success"; 
      }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLPA10 with ltv at maximum of 95
  async MTGLPA10_LtvMax95() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '95', pCltv: '95', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLPA10 with ltv just over maximum at 95.01
  async MTGLPA10_LtvOverMax95() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '95.01', pCltv: '95.01', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA10 with fico at minimum of 620
  async MTGLPA10_FicoMin620() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '620',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLPA10 with ltv just under minimum at 619
  async MTGLPA10_FicoUnder619() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '619',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Low FICO Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA10 with dti just over maximum at 50.01
  async MTGLPA10_DtiOver50() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '780',
        pDtiFront: '45', pDtiBack: '50.01',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding DTI Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA10 with ltv just over maximum at 85.01
  async MTGLPA10_2UnitLtvOver85() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '85.01', pCltv: '85.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA10 with ltv just over maximum at 80.01
  async MTGLPA10_4UnitLtvOver80() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '4 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '80.01', pCltv: '80.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA10 with 2nd home ltv at 90
  async MTGLPA10_SecondHomeLtv90() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '90', pCltv: '90', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLPA10 with 2nd home ltv just over maximum at 90.01
  async MTGLPA10_SecondHomeLtvOver90() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '90.01', pCltv: '90.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA10 with 2nd home with 2 units
  async MTGLPA10_SecondHome2Unit() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '80', pCltv: '80', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Multi-Unit Second Home Not Supported"; }
      else { return "Success" };
    }
  }

  // MTGLPA10 with investment ltv 80 fico 620
  async MTGLPA10_InvestmentLtv80Fico620() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'Condo (Detached)', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '80', pCltv: '80', pFico: '620',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLPA10 with investment ltv 85 fico 620
  async MTGLPA10_InvestmentLtv85Fico620() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '85', pCltv: '85', pFico: '620',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Low FICO Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA10 with investment ltv 85 fico 680
  async MTGLPA10_InvestmentLtv85Fico680() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'Condo (Detached)', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '85', pCltv: '85', pFico: '680',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLPA10 with investment 2 unit ltv over 75
  async MTGLPA10_Investment2UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '620',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA10 with investment 2 unit fico under 620
  async MTGLPA10_Investment2UnitFico619() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75', pCltv: '75', pFico: '619',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Low FICO Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA10 with R/T, 1 Unit, LTV 95
  async MTGLPA10_RateTermPrimarySfrLtv95() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '95', pCltv: '95', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLPA10 with R/T, 2 Unit, LTV 85.01
  async MTGLPA10_RateTermPrimary2UnitLtvOver85() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '85.01', pCltv: '85.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA10 with R/T, 3 Unit, LTV 75.01
  async MTGLPA10_RateTermPrimary3UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: '3 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLPA10 with R/T, Investment, 1 Unit, LTV 75.01
  async MTGLPA10_RateTermInvestment1UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLPA10 with R/T, Investment, 2 Unit, LTV 75.01
  async MTGLPA10_RateTermInvestment2UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '85.01', pCltv: '85.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA10 with C/O, 1 Unit, LTV 80.01
  async MTGLPA10_CashOutPrimaryPudLtvOver80() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '80.01', pCltv: '80.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA10 with C/O, 4 Unit, LTV 75.01
  async MTGLPA10_CashOutPrimary4UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: '4 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA10 with C/O, 2nd Home, 1 Unit, LTV 75.01
  async MTGLPA10_CashOutSecondHomePudLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA10 with C/O, Investment, 1 Unit, LTV 75.01
  async MTGLPA10_CashOutInvestmentPudLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA10 with C/O, Investment, 3 Unit, LTV 70.01
  async MTGLPA10_CashOutInvestment3UnitLtvOver70() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA10', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: '3 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '70.01', pCltv: '70.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // standard MTGLPA7 parameters that should have no errors
  async MTGLPA7_Standard() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '65', pCltv: '65', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLPA7 with loan amount exceeding allowed
  async MTGLPA7_LoanLimitHigh() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '850000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '65', pCltv: '65', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Success"; } // no progams should be returned
      else { return "Error: No Programs Should Have Been Returned"; }
    }
  }

  // MTGLPA7 adjustments Condo, Second Home, Second Loan
  async MTGLPA7_CondoSecondHomeSecondLoan() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '100000', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'Condo (Attached)', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '50', pCltv: '60', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) {
        if(!programs[0].priceAdjustments || programs[0].priceAdjustments.length !== 4) { return "Error: Expected Price Adjustments Not Returned"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'ARM')) { return "Error: Price Adjusment Missing (ARM)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Condo')) { return "Error: Price Adjusment Missing (Condo)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Second Home')) { return "Error: Price Adjusment Missing (Second Home)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Subordinate Financing')) { return "Error: Price Adjusment Missing (Subordinate Financing)"; }
        return "Success"; 
      }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLPA7 adjustments 2 Unit, Investment
  async MTGLPA7_2UnitInvestment() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { 
        if(!programs[0].priceAdjustments || programs[0].priceAdjustments.length !== 3) { return "Error: Expected Price Adjustments Not Returned"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'ARM')) { return "Error: Price Adjusment Missing (ARM)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, '2 to 4 Unit')) { return "Error: Price Adjusment Missing (2 to 4 Unit)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'Investment Property')) { return "Error: Price Adjusment Missing (Investment Property)"; }
        return "Success"; 
      }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLPA7 adjustments 4 Unit, C/O
  async MTGLPA7_4UnitCashOut() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: '4 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { 
        if(!programs[0].priceAdjustments || programs[0].priceAdjustments.length !== 3) { return "Error: Expected Price Adjustments Not Returned"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'MTGLPA7 LLPA')) { return "Error: Price Adjusment Missing (MTGLPA7 LLPA)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, 'ARM')) { return "Error: Price Adjusment Missing (ARM)"; }
        if(!itemInAdjList(programs[0].priceAdjustments, '2 to 4 Unit')) { return "Error: Price Adjusment Missing (2 to 4 Unit)"; }
        return "Success"; 
      }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLPA7 with ltv at maximum of 95
  async MTGLPA7_LtvMax95() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '95', pCltv: '95', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLPA7 with ltv just over maximum at 95.01
  async MTGLPA7_LtvOverMax95() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '95.01', pCltv: '95.01', pFico: '780',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA7 with fico at minimum of 620
  async MTGLPA7_FicoMin620() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '620',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLPA7 with ltv just under minimum at 619
  async MTGLPA7_FicoUnder619() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '619',
        pDtiFront: '20', pDtiBack: '35',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Low FICO Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA7 with dti just over maximum at 50.01
  async MTGLPA7_DtiOver50() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '50', pCltv: '50', pFico: '780',
        pDtiFront: '45', pDtiBack: '50.01',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding DTI Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA7 with ltv just over maximum at 85.01
  async MTGLPA7_2UnitLtvOver85() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '85.01', pCltv: '85.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA7 with ltv just over maximum at 80.01
  async MTGLPA7_4UnitLtvOver80() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '4 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '80.01', pCltv: '80.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA7 with 2nd home ltv at 90
  async MTGLPA7_SecondHomeLtv90() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '90', pCltv: '90', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLPA7 with 2nd home ltv just over maximum at 90.01
  async MTGLPA7_SecondHomeLtvOver90() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '90.01', pCltv: '90.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA7 with 2nd home with 2 units
  async MTGLPA7_SecondHome2Unit() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '80', pCltv: '80', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Multi-Unit Second Home Not Supported"; }
      else { return "Success" };
    }
  }

  // MTGLPA7 with investment ltv 80 fico 620
  async MTGLPA7_InvestmentLtv80Fico620() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'Condo (Detached)', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '80', pCltv: '80', pFico: '620',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLPA7 with investment ltv 85 fico 620
  async MTGLPA7_InvestmentLtv85Fico620() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '85', pCltv: '85', pFico: '620',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Low FICO Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA7 with investment ltv 85 fico 680
  async MTGLPA7_InvestmentLtv85Fico680() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: 'Condo (Detached)', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '85', pCltv: '85', pFico: '680',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLPA7 with investment 2 unit ltv over 75
  async MTGLPA7_Investment2UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '620',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA7 with investment 2 unit fico under 620
  async MTGLPA7_Investment2UnitFico619() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '1', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75', pCltv: '75', pFico: '619',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Low FICO Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA7 with R/T, 1 Unit, LTV 95
  async MTGLPA7_RateTermPrimarySfrLtv95() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '95', pCltv: '95', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLPA7 with R/T, 2 Unit, LTV 85.01
  async MTGLPA7_RateTermPrimary2UnitLtvOver85() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '85.01', pCltv: '85.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA7 with R/T, 3 Unit, LTV 75.01
  async MTGLPA7_RateTermPrimary3UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: '3 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLPA7 with R/T, Investment, 1 Unit, LTV 75.01
  async MTGLPA7_RateTermInvestment1UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: 'SFR', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length === 0) { return "Success"; }
      else { return "Error: " + programs[0].issues[0]; }
    }
  }

  // MTGLPA7 with R/T, Investment, 2 Unit, LTV 75.01
  async MTGLPA7_RateTermInvestment2UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '2', // purchase, r/t refi, c/o refi
        pPropertyType: '2 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '85.01', pCltv: '85.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA7 with C/O, 1 Unit, LTV 80.01
  async MTGLPA7_CashOutPrimaryPudLtvOver80() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '80.01', pCltv: '80.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA7 with C/O, 4 Unit, LTV 75.01
  async MTGLPA7_CashOutPrimary4UnitLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: '4 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '1', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA7 with C/O, 2nd Home, 1 Unit, LTV 75.01
  async MTGLPA7_CashOutSecondHomePudLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '2', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA7 with C/O, Investment, 1 Unit, LTV 75.01
  async MTGLPA7_CashOutInvestmentPudLtvOver75() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: 'PUD', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '75.01', pCltv: '75.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  // MTGLPA7 with C/O, Investment, 3 Unit, LTV 70.01
  async MTGLPA7_CashOutInvestment3UnitLtvOver70() {
    const res = await axios.get('/program', {
      params: {
        pTimestamp: '', // latest rates
        pProgCode: 'MTGLPA7', // specific program code
        pProgFamily: '',
        pDocumentType: '1', // full doc, portfolio
        pLoanType: '1', // fixed, adjustable
        pLoanTerm: '30',
        pCounty: 'Los Angeles', pState: 'CA',
        pFirstLoanAmt: '500000',  pSecondLoanAmt: '0', 
        pLoanPurpose: '3', // purchase, r/t refi, c/o refi
        pPropertyType: '3 Unit', // SFR, Condo (A), Condo (D), PUD, 2-4 Unit
        pOccupancyType: '3', // primary, second home, investment
        pLtv: '70.01', pCltv: '70.01', pFico: '780',
        pDtiFront: '50', pDtiBack: '50',
        pLockPeriod: '2', // 15 Day, 30 Day
        pPmi: '1', // No PMI, Borrower Paid, Lender Paid
        pIncomeVerification: 1,
        pEscrow: '1', // 1 - No Impound, 2 - Tax and Insurance, 3 - Tax, 4 - Insurance
        pForeignNational: '2', // 1 - Yes, 2 - No
        pMonthsReserves: '2', // 1 - 2 months, 2 - 6 months, 3 - 12 months
        pPrepayPenalty: '1', // 1 - no prepay, 2 - 1 year, 3 - 2 year
      },
    });
    if (!res || res.error) { return "Error: Server Connection Issue"; } 
    else {
      const programs = res.data;
      if(!programs || programs.length === 0) { return "Error: No Programs Returned From Server"; }
      if(programs.length > 1) { return "Error: More Than One Progam Returned"; }
      if(programs[0].issues.length !== 1) { return "Error: Unexpected Issue Count Returned"; }
      if(!itemInStrList(programs[0].issues, "Failed Validation (LTV/DTI/FICO)")) { return "Error: Exceeding LTV Limit Not Handled"; }
      else { return "Success" };
    }
  }

  async RunMyTest() {
    const res = await axios.get('/SandboxCode');
  }

  render() {
    const { testRunning, testStatus, failCount, passCount, errorLog } = this.state;

    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h1 className="h4 text-uppercase">
              Unit Tests
            </h1>
          </div>
        </div>

        {/* <button
          className="btn btn-primary"
          disabled={testRunning}
          onClick={() => this.RunMyTest()}
        >
          Run Test Code
        </button> */}

        <div className="row">
          <div className="col-12 col-md-12 mb-2">
            <div className="border rounded px-3 py-2 bg-white">
              <div style={{marginTop:'10px'}}>
                <button
                  className="btn btn-primary"
                  disabled={testRunning}
                  onClick={() => this.RunUnitTests()}
                >
                  Run Tests
                </button>
                {testRunning && (
                  <button
                    style={{marginLeft:'10px'}}
                    className="btn btn-secondary"
                    onClick={() => this.setState({abortTest: true})}
                  >
                    Cancel
                  </button>
                )}
                {testRunning && (
                  <span style={{marginLeft:'10px', marginRight:'-10px'}}>
                    <img src="/images/spinner.gif" alt="" height="36px" width="36px" />
                  </span>
                )}
                {testStatus && (
                  <span style={{marginLeft:'20px', color:'gray', fontSize:'13px'}}>{testStatus}</span>
                )}
              </div>
              <table style={{fontSize:'13px', color:'gray', marginTop:'25px'}}><tbody>
                <tr><td colSpan={3}>Test Results:</td></tr>
                <tr>
                  <td style={{paddingLeft:'20px', paddingRight:'5px'}}>Pass</td>
                  <td>(<span style={{color:'green'}}>{passCount}</span>)</td>
                  <td style={{color:'green', paddingLeft:'10px', textAlign:'center'}}>{(passCount + failCount) === 0 ? '--%' : (passCount / (passCount + failCount) * 100).toFixed(2) + '%'}</td>
                </tr>
                <tr>
                  <td style={{paddingLeft:'20px', paddingRight:'5px'}}>Fail</td>
                  <td>(<span style={{color:'red'}}>{failCount}</span>)</td>
                  <td style={{color:'red', paddingLeft:'10px', textAlign:'center'}}>{(passCount + failCount) === 0 ? '--%' : (failCount / (passCount + failCount) * 100).toFixed(2) + '%'}</td>
                </tr>
              </tbody></table>
              {(errorLog && errorLog.length > 0) && (
                <div>
                  <hr/>
                  <div style={{fontSize:'13px', color:'gray', marginBottom:'10px'}}>Error Log:</div>
                  {errorLog.map(err => (
                    <div key={err} style={{marginBottom:'10px'}}>
                      {err.split('\n').map(lines => (
                        <div key={lines} style={{fontSize:'12px', color:'gray', marginLeft:'20px'}}>{lines}</div>
                      ))}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
